var _g, _rect, _circle, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEVital(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 306,
    viewBox: "0 0 392 306",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_469_1683)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 45,
    y: 37,
    width: 286,
    height: 200,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 52,
    width: 30,
    height: 15,
    rx: 7.5,
    fill: "#01B187"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 308.5,
    cy: 59.5,
    r: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 115,
    width: 198,
    height: 44,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_469_1683",
    x: 0,
    y: 0,
    width: 392,
    height: 306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_469_1683"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 8,
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_469_1683"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_469_1683",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_469_1683",
    transform: "scale(0.00505051 0.0227273)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_469_1683",
    width: 198,
    height: 44,
    xlinkHref: "data:image/png;base64,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"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEVital);
export default __webpack_public_path__ + "static/media/eVital.3d7df991bd871b03dc424150ddf4a470.svg";
export { ForwardRef as ReactComponent };